/**
 * B-7202: the server-side opt-out for the post-export dialog + summary email,
 * as the Settings switch reads and writes it. Split out of V2SettingsPage.
 */
import { useEffect, useState } from 'react';
import { BackendAPI } from '../../lib/api';

/** [show the dialog (null until loaded), toggle it; reverts on a failed save]. */
export function useExportSummaryPref(): [boolean | null, (_on: boolean) => void] {
  // null = not loaded yet (the switch stays disabled rather than guessing).
  const [showExportSummary, setShowExportSummary] = useState<boolean | null>(null);

  useEffect(() => {
    let alive = true;
    BackendAPI.getExportPreferences()
      .then((p) => alive && setShowExportSummary(!p.hide_export_dialog))
      .catch(() => alive && setShowExportSummary(true));
    return () => {
      alive = false;
    };
  }, []);

  const toggleExportSummary = (on: boolean) => {
    const before = showExportSummary;
    setShowExportSummary(on);
    BackendAPI.setExportPreferences({ hide_export_dialog: !on }).catch(() =>
      setShowExportSummary(before),
    );
  };

  return [showExportSummary, toggleExportSummary];
}
